import Crud from './crud'
var crud = new Crud('bank-info', 'ngân hàng');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        BankName: '',
        IsActive: 1
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};